class recordRecentlyViewedProducts extends HTMLElement {
  constructor() {
    super();
    this.name = "minion_recently_viewed";
    
    this.recordRecentlyViewed();
  }
  config(){
    return {
      howManyToStoreInMemory: Number(this.getAttribute('data-count'))+1,
      settings: this.getAttribute('data-settings')
    };
  }
  setCookie(name,value,days) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days*24*60*60*1000));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
  }
  getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
      var c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) == 0) {
        var arr = c.substring(nameEQ.length,c.length);
        return arr.split(' ');
      }
    }
    return [];
  }
  recordRecentlyViewed(){ 
    var config = this.config(),
        recentlyViewed = this.getCookie(this.name);
    if (window.location.pathname.indexOf('/products/') !== -1) {
      var productHandle = document.querySelector('[data-product-handle]').getAttribute('data-product-handle'),
          position = -1;
      if(recentlyViewed){
        position = recentlyViewed.indexOf(productHandle);
      }
      if (position === -1) {
        recentlyViewed.unshift(productHandle);
        recentlyViewed = recentlyViewed.splice(0, config.howManyToStoreInMemory);
      }
      else {
        recentlyViewed.splice(position, 1);
        recentlyViewed.unshift(productHandle);              
      }
      this.setCookie(this.name,recentlyViewed.join(' '),1);
    }
  }
}
class recentlyViewedProducts extends recordRecentlyViewedProducts {
  constructor() {
    super();
    
    var currentproducts = this.getCookie(this.name);
    if(currentproducts.length <= 1) return;

    if (window.location.pathname.indexOf('/products/') !== -1) {
      var productHandle = document.querySelector('[data-product-handle]').getAttribute('data-product-handle'),
          index = currentproducts.indexOf(productHandle);
      if (index !== -1) currentproducts.splice(index, 1);
    }
    this.getProducts(currentproducts);
  }
  /* TOPSAFE: cada producto se pide a /products/<handle>?view=tsc-card (plantilla templates/product.tsc-card.liquid).
     El método anterior (/collections/all?view=ajax_recently_viewed&constraint=...) ya no devolvía productos
     y dejaba el título "Vistos recientemente" solo. La sección se muestra únicamente si hay tarjetas. */
  getProducts(handles){
    var _this = this;
    var o = (this.config().settings || '').split('___');
    var limit = Number(o[18]) || 10;
    var swipe = o[1] === 'true';
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var list = handles.filter(Boolean).slice(0, limit);
    Promise.all(list.map(function (h) {
      return fetch(root + 'products/' + encodeURIComponent(h) + '?view=tsc-card')
        .then(function (r) { return r.ok ? r.text() : ''; })
        .catch(function () { return ''; });
    })).then(function (cards) {
      cards = cards.filter(function (c) { return c.indexOf('product-card') !== -1; });
      if (!cards.length) return;
      var col = 'col-sp-' + (o[4] || '6') + ' ' + (o[3] || 'col-md-4').replace(/--/g, ' ') + (swipe ? ' slider__slide' : '');
      var html = '<slider-component class="grid el_mt_40 ' + (o[0] || '') + (swipe ? ' slider slider--phone' : '') + '">' +
        cards.map(function (c) { return '<div class="' + col + '">' + c + '</div>'; }).join('') + '</slider-component>';
      _this.querySelector('.recently-viewed-products-content').insertAdjacentHTML('beforeend', html);
      _this.classList.remove('hide');
    });
  }
}

customElements.define('recently-viewed-products', recentlyViewedProducts);
!document.querySelector('recently-viewed-products') && customElements.define('recently-viewed-products-record', recordRecentlyViewedProducts);